import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetCashtagRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetCashtagResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setCashtag = (request: SetCashtagRequest, options?: CashRequestOptions) =>
  post<SetCashtagRequest, SetCashtagResponse>('/2.0/cash/set-cashtag', request, { ...options, rejectOnError: true })
